import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, exhaustMap } from 'rxjs/operators';

import { AvailabilityActions } from '../actions';
import { AvailabilityService } from '../availability.service';


@Injectable()
export class AvailabilityEffects {
  private availabilityService = inject(AvailabilityService);
  private actions$ = inject(Actions);

  loadAvailabilities$ = createEffect(() => this.actions$
    .pipe(
      ofType(AvailabilityActions.loadAvailabilities),
      exhaustMap(({ product, destination, dateOfStay }) => this.availabilityService
        .getAvailabilities({
          productId: product.id,
          destinationId: destination.id as number,
          startDate: dateOfStay.start!,
          endDate: dateOfStay.end!,
        })
        .pipe(
          map(availabilities => AvailabilityActions.loadAvailabilitiesSuccess({ availabilities })),
          catchError(error => of(AvailabilityActions.loadAvailabilitiesFailure({ error }))),
        ),
      ),
    ),
  );
}

